import script from "./DocumentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentForm.vue?vue&type=script&setup=true&lang=js"

import "./DocumentForm.vue?vue&type=style&index=0&id=3d620b76&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d620b76"]])

export default __exports__